import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d849rxmheb: FaireBrandEntity = {
  token: "b_d849rxmheb",
  type: "brand",
  name: "Trendy Tee Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/4fad1f58c2da7128f7ad27874b3c26dcd195e4d61ab5c0425667898287304bd0.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8af367e22e6724c4793df5e9d88f780ae0a2b29945790011b948e09a5d64467a.webp",
  logoUrl:
    "https://cdn.faire.com/fastly/4fad1f58c2da7128f7ad27874b3c26dcd195e4d61ab5c0425667898287304bd0.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8af367e22e6724c4793df5e9d88f780ae0a2b29945790011b948e09a5d64467a.webp",
  location: "Indianola, IA, USA",
  minimumOrderDollars: 139,
  rating: 4.9,
  reviewCount: 180,
  isTopShop: true,
  isInsider: true,
  description:
    "Trendy Tee Co. started from a desire to provide high quality graphic tshirts with fresh designs and an affordable price point to boutiques around the globe. We are a woman and veteran owned company based out of Iowa. We hope to share our midwest values with our customers and build a long lasting relationship.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:22.647Z",
    importedBy: "entity-db-cli",
  },
};
